import DefaultLayout from "./DefaultLayout"

// export default withAuth(DefaultLayout);
export default DefaultLayout
